import { companyConfig } from 'globalConfigApp'

const params = {
  simpleSrp: {
    title: `Vende, Compra o Renta en confianza con ${companyConfig.name}`,
    subTitle:
      'Estamos aquí para guiarlo y responder a sus preguntas con datos precisos y los mejores expertos locales',
    image: 'landing/hero/srp/photo-68360119.jpg',
    buttons: []
  },
  home: {
    title: `Vende, Compra o Renta en confianza con ${companyConfig.name}`,
    buttons: [],
    customStyles: {},
    heroTypeClass: 'solid-hero',
  },
  srp: {
    title: `Vende, Compra o Renta en confianza con ${companyConfig.name}`,
    subTitle:
      'Estamos aquí para guiarlo y responder a sus preguntas con datos precisos y los mejores expertos locales',
    image: 'landing/hero/srp/DSC00055.jpg',
    buttons: []
  },
  about: {
    title:
      'Nos encargamos de todo tu trabajo administrativo para que te enfoques en tus actividades más productivas',
    subTitle: '',
    image: 'landing/hero/about/hi-i.jpg',
    buttons: [
      // {
      //   title: 'Aprende más',
      //   href: '/about',
      //   color: 'primary',
      //   outline: true,
      //   variation: true

      // },
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  administrative: {
    title:
      'Nos encargamos de todo tu trabajo administrativo para que te enfoques en tus actividades más productivas',
    subTitle: '',
    image: 'landing/hero/administrative/hi-f.jpg',
    buttons: [
      // {
      //   title: 'Aprende más',
      //   href: '/about',
      //   href: '/about',
      //   color: 'primary',
      //   outline: true,
      //   variation: true

      // },
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  development: {
    title: 'Oportunidades de crecimiento personal y profesional',
    subTitle: '',
    image: 'landing/hero/development/hi-e.jpg',
    buttons: [
      // {
      //   title: 'Aprende más',
      //   href: '/about',
      //   color: 'primary',
      //   outline: true,
      //   variation: true

      // },
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  homepage: {
    title:
      `Transforma tu vida y la de tus clientes con ${companyConfig.name}, la nueva alianza inmobiliaria de México `,
    subTitle: `Gana el 75% de comisiones con ${companyConfig.name}`,
    image: 'landing/hero/homepage/hi-a.jpg',
    buttons: [
      // {
      //   title: 'Aprende más',
      //   icon: '',
      //   href: '/about',
      //   color: 'primary',
      //   outline: true,
      //   variation: true
      // },
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  transactionManagement: {
    title: 'Gestiona toda tu transaccion a traves de nuestro CRM interno',
    subTitle: `Gana el 75% de comisiones con ${companyConfig.name}`,
    image: 'landing/hero/management/hi-g.jpg',
    buttons: [
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  promoteYourProperties: {
    title: `Gana el 75% de comisiones con ${companyConfig.name}`,
    subTitle: 'Todos los servicios que necesitas a un precio fijo.',
    image: '/landing/hero/promote/hi-c.jpg',
    buttons: [
      {
        title: 'Comienza',
        href: '/signup',
        asUrl: 'registrarse',
        icon: '',
        color: 'primary',
        outline: true,
        variation: true
      },
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  'acquire-more-properties': {
    title:
      'Adquiere mas propiedades en exclusivas con nuestro servicio exclusivo de captación de propiedades',
    subTitle: `Gana el 75% de comisiones con ${companyConfig.name}`,
    image: '/landing/hero/more-properties/hi-b.jpg',
    buttons: [
      {
        title: 'Comienza',
        href: '/signup',
        asUrl: 'registrarse',
        icon: '',
        color: 'primary',
        outline: true,
        variation: true
      },
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  betterServeYourClients: {
    title:
      'Vende o Renta más rapido con el paquete de multi-difusion más potente de México',
    subTitle: '',
    image: 'landing/hero/services/hi-d.jpg',
    buttons: [
      {
        title: 'Comienza',
        href: '/signup',
        asUrl: 'registrarse',
        color: 'primary',
        outline: true,
        variation: true
      },
      {
        title: 'Me interesa',
        href: '/signup',
        asUrl: '/registrarse',
        color: 'primary'
      }
    ]
  },
  prices: {
    title: 'Elige el plan perfecto para ti',
    subTitle: 'Todos los servicios que necesitas a un precio fijo.',
    image: 'landing/hero/prices/hi-h.jpg',
    buttons: []
  },
  help: {
    title: 'Hola, ¿En qué podemos ayudarte?',
    subTitle: '',
    image: '/hero/faq/hero-help.png',
    buttons: []
  },
  defaultConfig: {
    title: '',
    subTitle: '',
    image: '',
    buttons: []
  }
}

export default function heroConfiguration(type) {
  return params[type] ? params[type] : params['defaultConfig']
}
